// @flow

import React from 'react'
import StandardContactForm from '@/components/Forms/StandardContactForm'

type Props = {
  action: String,
}

export default ({ action }: Props) => (
  <StandardContactForm
    name="TEST Form Disregard"
    action={action}
    submitLabel="Get Brochure"
  />
)
